import { inject } from 'vue'
import type { AppConfig } from '@/configLoader'

export function useConfig(): AppConfig {
  const config = inject<AppConfig>('config')
  
  if (config)
  {
    config.apiBaseUrl = config.apiBaseUrl.replace(/\/+$/, ''); // Remove trailing slash
    config.productPageBaseUrl = config.productPageBaseUrl.replace(/\/+$/, '');
    config.productImageBaseUrl = config.productImageBaseUrl.replace(/\/+$/, '');
  }

  if (!config) throw new Error('App config not provided')
  return config
}
